import { personalizedSlipSchema } from "@redotech/redo-model/personalized-slip/personalized-slip-definition";
import * as z from "zod/v4";

export const createPersonalizedSlipTemplate = {
  name: "createPersonalizedSlipTemplate" as const,
  input: z.object({
    teamId: z.string(),
    name: z.string(),
    copyFromTemplateId: z.string().optional(),
  }),
  output: personalizedSlipSchema,
};
